import React from "react";
import {CATEGORIES} from "../../../../utils/constants";
import {ICase} from "../../../../types/Case";
import {ApplicationCard} from "../ApplicationCard";

interface ApplicationListProps {
  cases: ICase[];
  onClickBrowseButton: (c: ICase) => void;
  onClickSurveyButton: (c: ICase) => void;
}

export const ApplicationList = ({
  cases,
  onClickBrowseButton,
  onClickSurveyButton,
}: ApplicationListProps) => (
  <React.Fragment>
    {
      cases.map((item: ICase) => {
        const categoryItem = CATEGORIES.find(i => i.path === item.category) || {
          label: item.category,
          color: "bg-gray-200",
          icon: null
        };
        return (
          <ApplicationCard
            key={item.id}
            item={item}
            categoryItem={categoryItem}
            onClickBrowseButton={() => onClickBrowseButton(item)}
            onClickSurveyButton={() => onClickSurveyButton(item)}
          />
        );
      })}
  </React.Fragment>
)